module.exports = __webpack_public_path__ + "images/login-background.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/login/login-background.jpg
// module id = 1456
// module chunks = 0